// Shared loading skeleton for both screens (queue + workspace). Root
// CLAUDE.md: "Size rows... against the AMHARIC rendering, never the
// English one." — the row height below (56px) is sized against Amharic
// glyphs (which run taller than Latin, with more vertical reach for
// vowel-order marks), not the shorter English line it might otherwise be
// tempted to match. Verified visually is not something this session can
// do (no browser tool — see this task's final report), but the value is
// deliberately generous rather than a Latin-sized guess.

import styles from './LoadingState.module.css';

export default function LoadingState({ variant = 'rows', rows = 5 }) {
  if (variant === 'page') {
    return (
      <div className={styles.page} role="status" aria-live="polite">
        <div className={`${styles.block} ${styles.title} skeleton`} />
        <div className={`${styles.block} ${styles.line} skeleton`} />
        <div className={`${styles.block} ${styles.line} skeleton`} />
      </div>
    );
  }

  return (
    <div className={styles.rows} role="status" aria-live="polite">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className={`${styles.row} skeleton`} />
      ))}
    </div>
  );
}
